import { Form } from "formik";
import styled from "styled-components";
import { colorTheme, textTheme } from "../../../../theme";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const Header = styled.h3`
  color: ${colorTheme.black};
  ${textTheme.h3};
  margin: 0;
  padding: 0;
`;

export const SubHeader = styled.h6`
  color: ${colorTheme.black};
  ${textTheme.h6};
  margin: 0;
  padding: 0;
`;

export const StyledForm = styled(Form)`
  display: flex;
  flex-direction: column;
  position: relative;
  width: 100%;
`;

export const TopSaveWrapper = styled.div`
  position: absolute;
  right: 0;
`;

export const Section = styled.div`
  display: flex;
  flex-direction: column;
  align-content: start;
  gap: 20px;
  width: 436px;
  padding-left: 150px;
`;
